 
export default {
  '433f226d-90a3-49a8-9e2f-25ab1fa42c62': {
    numberOfDots: 4,
    loadingDelayPerItem: 1000,
    steps: [
      {
        title: 'Find the best package for you',
        options: [
          {
            text: 'Internet',
            key: 'package',
            value: 'internet',
            next: 2,
            loading: {
              title: 'Package',
              description: 'Internet',
            },
          },
          {
            text: 'Phone',
            key: 'package',
            value: 'phone',
            next: 2,
            loading: {
              title: 'Package',
              description: 'Phone',
            },
          },
          {
            text: 'TV',
            key: 'package',
            value: 'tv',
            next: 2,
            loading: {
              title: 'Package',
              description: 'TV',
            },
          },
          {
            text: 'Bundles',
            key: 'package',
            value: 'bundles',
            next: 2,
            loading: {
              title: 'Package',
              description: 'Bundles',
            },
          },
        ],
      },
      {
        title: 'What kind of business do you run?',
        options: [
          {
            text: 'Office',
            key: 'business_type',
            value: 'office',
            next: 3,
            loading: {
              title: 'Kind of business',
              description: 'Office',
            },
          },
          {
            text: 'Retail',
            key: 'business_type',
            value: 'retail',
            next: 3,
            loading: {
              title: 'Kind of business',
              description: 'Retail',
            },
          },
          {
            text: 'Hospitality',
            key: 'business_type',
            value: 'hospitality',
            next: 3,
            loading: {
              title: 'Kind of business',
              description: 'Hospitality',
            },
          },
          {
            text: 'Other',
            key: 'business_type',
            value: 'other',
            next: 3,
            loading: {
              title: 'Kind of business',
              description: 'Other',
            },
          },
        ],
      },
      {
        title: 'How big is your business?',
        options: [
          {
            text: 'Small (0-49 Employees)',
            key: 'business_size',
            value: 'small',
            next: null,
            loading: {
              title: 'How many employees',
              description: 'Small (0-49 Employees)',
            },
          },
          {
            text: 'Medium (50-499 Employees)',
            key: 'business_size',
            value: 'small',
            next: null,
            loading: {
              title: 'How many employees',
              description: 'Medium (50-499 Employees)',
            },
          },
          {
            text: 'Enterprise (500+ Employees)',
            key: 'business_size',
            value: 'small',
            next: null,
            loading: {
              title: 'How many employees',
              description: 'Enterprise (500+ Employees)',
            },
          },
        ],
      },
    ],
  },
}
